import React from 'react';
import styled from 'styled-components';

const SelectionContainer = styled.div`
    width: 100%;
    //max-width: 600px;
    padding: 20px;
    text-align: center;
    max-height: 100vh; /* Limit height to viewport height */
    overflow-y: auto; /* Enable vertical scrolling */
    -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
`;

const Title = styled.h1`
    font-size: 2rem;
    margin-bottom: 2rem;
    color: #333;
`;

const VegetableGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 15px;
    padding-bottom: 20px; /* Add padding at bottom for better scroll experience */
`;

const VegetableCard = styled.div`
  padding: 15px;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

const VegetableName = styled.p`
  margin-top: 10px;
  font-weight: bold;
`;

const vegetables = [
    { id: 1, name: 'Carrot', emoji: '🥕' },
    { id: 2, name: 'Potato', emoji: '🥔' },
    { id: 3, name: 'Broccoli', emoji: '🥦' },
    { id: 4, name: 'Cucumber', emoji: '🥒' },
    { id: 5, name: 'Tomato', emoji: '🍅' },
    { id: 6, name: 'Onion', emoji: '🧅' },
    { id: 7, name: 'Garlic', emoji: '🧄' },
    { id: 8, name: 'Turnip', emoji: '🪴' },
    { id: 9, name: 'Aubergine', emoji: '🍆' },
];

const VegetableSelection = ({ onSelect }) => {
    return (
        <SelectionContainer>
            <Title>Choose Your Vegetable</Title>
            <VegetableGrid>
                {vegetables.map((veg) => (
                    <VegetableCard key={veg.id} onClick={() => onSelect(veg)}>
                        <span style={{ fontSize: '2rem' }}>{veg.emoji}</span>
                        <VegetableName>{veg.name}</VegetableName>
                    </VegetableCard>
                ))}
            </VegetableGrid>
        </SelectionContainer>
    );
};

export default VegetableSelection;
